var _defs, _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 300,
    zoomAndPan: "magnify",
    viewBox: "0 0 224.87999 225",
    height: 300,
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "beb49a5bd8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 18.785156 18.84375 L 206.183594 18.84375 L 206.183594 206.242188 L 18.785156 206.242188 Z M 18.785156 18.84375 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "4803422d50"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0 0.0585938 L 224.761719 0.0585938 L 224.761719 224.9375 L 0 224.9375 Z M 0 0.0585938 ",
    clipRule: "nonzero"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#beb49a5bd8)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#d3d3d3",
    d: "M 112.484375 18.84375 C 60.734375 18.84375 18.785156 60.792969 18.785156 112.542969 C 18.785156 164.292969 60.734375 206.242188 112.484375 206.242188 C 164.234375 206.242188 206.183594 164.292969 206.183594 112.542969 C 206.183594 60.792969 164.234375 18.84375 112.484375 18.84375 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#4803422d50)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#115ca2",
    d: "M 112.40625 0.015625 C 174.511719 0.015625 224.859375 50.363281 224.859375 112.46875 C 224.859375 174.574219 174.511719 224.917969 112.40625 224.917969 C 50.300781 224.917969 -0.0429688 174.574219 -0.0429688 112.46875 C -0.0429688 50.363281 50.300781 0.015625 112.40625 0.015625 Z M 126.480469 101.835938 L 126.480469 168.742188 C 126.480469 187.355469 98.332031 187.355469 98.332031 168.742188 L 98.332031 101.835938 C 98.332031 83.222656 126.480469 83.222656 126.480469 101.835938 Z M 112.40625 42.21875 C 121.089844 42.21875 128.136719 49.253906 128.136719 57.949219 C 128.136719 66.632812 121.089844 73.679688 112.40625 73.679688 C 103.722656 73.679688 96.675781 66.632812 96.675781 57.949219 C 96.675781 49.253906 103.722656 42.21875 112.40625 42.21875 Z M 112.40625 42.21875 ",
    fillOpacity: 1,
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.71f3017cebbaf040e2f98e78ffaa9ff0.svg";
export { ForwardRef as ReactComponent };